

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERSTATUSCOUNT= createAsyncThunk(
  "getUserStatsCount/getUserStatsCount",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserStatsCountSlice = createSlice({
  name: "getUserStatsCountSlice",
  initialState: {
    getUserStatsCount: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserStatsCount: (state) => {
        state.getUserStatsCount.loading = false
        state.getUserStatsCount.error = false
        state.getUserStatsCount.data = []
        state.getUserStatsCount.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERSTATUSCOUNT.fulfilled, (state, action) => {
      state.getUserStatsCount = {
        ...state.getUserStatsCount,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSTATUSCOUNT.pending, (state, action) => {
      state.getUserStatsCount = {
        ...state.getUserStatsCount,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSTATUSCOUNT.rejected, (state, action) => {
      state.getUserStatsCount = {
        ...state.getUserStatsCount,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserStatsCountAction = {
    GETUSERSTATUSCOUNT,
};

export { getUserStatsCountAction };
export default getUserStatsCountSlice.reducer;
export const {setInitialStateOfgetUserStatsCount} = getUserStatsCountSlice.actions